import { Inject, Injectable } from '@angular/core';
import { CheckoutFacade } from '@checkout/data-access';
import {
  CHECKOUT_CONFIG,
  CheckoutConfig,
  CmsOrderConfirmationPage,
  CompletedQuoteDetails,
} from '@checkout/util-models';
import { CmsContainer } from '@domgen/dgx-fe-cms';
import { filterNullUndefined } from '@domgen/dgx-fe-common';
import { ComponentStore } from '@ngrx/component-store';
import { Observable, combineLatest, first, tap } from 'rxjs';
import { MentionMeService } from '../mention-me/mention-me.service';
interface ComponentState {
  completedQuotes: CompletedQuoteDetails[] | undefined;
  promotionFirstPaymentTitle: string | undefined;
}

export interface ViewModel {
  cmsData: CmsOrderConfirmationPage;
  completedQuotes: CompletedQuoteDetails[];
  promotionFirstPaymentTitle: string | undefined;
}

@Injectable()
export class OrderConfirmationComponentService extends ComponentStore<ComponentState> {
  private readonly completedQuotes$: Observable<CompletedQuoteDetails[]> =
    this.select((state: ComponentState) => state.completedQuotes).pipe(
      filterNullUndefined()
    );
  private readonly promotionFirstPaymentTitle$: Observable<string | undefined> =
    this.select((state: ComponentState) => state.promotionFirstPaymentTitle);

  readonly vm$: Observable<ViewModel> = combineLatest({
    cmsData: this.cmsContainer.content$,
    completedQuotes: this.completedQuotes$,
    promotionFirstPaymentTitle: this.promotionFirstPaymentTitle$,
  });

  constructor(
    @Inject(CHECKOUT_CONFIG) readonly checkoutConfig: CheckoutConfig,
    private readonly checkoutFacade: CheckoutFacade,
    private readonly cmsContainer: CmsContainer<CmsOrderConfirmationPage>,
    private readonly mentionMeService: MentionMeService
  ) {
    super({
      completedQuotes: undefined,
      promotionFirstPaymentTitle: checkoutConfig.promotionFirstPaymentTitle,
    });

    this.mentionMeService.init();
  }

  private readonly updateCompletedQuotes = this.updater(
    (state: ComponentState, completedQuotes: CompletedQuoteDetails[]) => ({
      ...state,
      completedQuotes,
    })
  )(this.checkoutFacade.completedQuotes$.pipe(first()));

  private readonly removeCompletedItems = this.effect(
    (trigger$: Observable<unknown>) =>
      trigger$.pipe(
        first(),
        tap(() => {
          this.checkoutFacade.removeCompletedItems();
        })
      )
  )(this.completedQuotes$);
}
